import { atom } from 'jotai';
import { StrapiUser } from '../../../core/models/strapi-user.model';

const userAtom = atom<StrapiUser | null>(null);

export { userAtom };
